export const stepConfig = [
  {target: '.analytics', key: 'analyticsOverview'},
  {target: '.AnalyticsContainer', key: 'analyticsWelcome'},
  {target: '.DropdownContainer', key: 'analyticsFilter'},
];
